export const SUPPORTED_FORMATS = {
  PDF: ".pdf",
  JPG: ".jpg,.jpeg",
  PNG: ".png"
} as const;

export const SUPPORTED_FORMATS_NAME = Object.keys(SUPPORTED_FORMATS).join(", ");
export const SUPPORTED_FORMATS_EXTENSION =
  Object.values(SUPPORTED_FORMATS).join(",");

export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB in bytes
export const MAX_FILE_SIZE_DISPLAY = "5MB";
